import api from '../api';

const PermissionsService = {
  getPermissions: (filters) => {
    return api.get(`permissions${filters}`);
  },
};

export { PermissionsService as default };
